@if (prefixContent()) {
    <span [attr.data-qa]="qaTag() + '-prefix'" aria-hidden="true" class="text-input-prefix">
        <ng-content select="[appContentPrefix]"/>
    </span>
}
<input #inputElement
       (blur)="onInputBlur()"
       (focus)="onInputFocus()"
       (input)="onInputChange($event)"
       [attr.aria-label]="ariaLabel()"
       [attr.autocomplete]="autocomplete()"
       [attr.data-qa]="qaTag()"
       [attr.maxlength]="effectiveMaxLength()"
       [attr.minlength]="minInputLength()"
       [attr.type]="type()"
       [class.has-prefix-content]="prefixContent()"
       [class.has-suffix-content]="suffixContent()"
       [disabled]="isDisabled || null"
       [id]="inputId()"
       [placeholder]="placeholder()"
       [value]="value()"
       [class.has-clear-button]="hasClearButton()"
       class="text-input"/>
@if (suffixContent()) {
    <span [attr.data-qa]="qaTag() + '-suffix'" class="text-input-suffix">
        <ng-content select="[appContentSuffix]"/>
    </span>
} @else if (hasClearButton() && value() && !isDisabled) {
    <app-button (clicked)="onClear()"
                [appButtonType]="AppButtonTypeEnum.ICON_ONLY_BUTTON"
                [buttonText]="'BUTTON.CLEAR' | translate"
                [qaTag]="qaTag() + '-clear-button'"
                [svgIcon]="ICONS.CLOSE"
                [tooltipData]="{tooltipPosition: TooltipPositionEnum.TOP, tooltipText: 'BUTTON.CLEAR' | translate}"
                class="text-input-clear-button"/>
}
